import { createSlice } from "@reduxjs/toolkit";

const initialStudentReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  personnelTypes: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentReportSlice = createSlice({
  name: "studentReport",
  initialState: initialStudentReportState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getStudentReport
    studentReportFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getPersonnelTypes
    personnelTypesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.personnelTypes = entities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanStudentReportState
    studentReportStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});